export const commonResources = {
  firstname: "First Name",
  lastname: "Last Name",
  email: "Email",
  required: "*",
  next: "Next",
  invalidCharacter: "Invalid character",
  inWord: "in word: ",
  pageNotFound: "Page Not Found",
  pageNotFoundDescription:
    "Uh oh, the page you were looking for does not exist. Try going back to the previous page or navigate to the ",
  home: "Home",
  page: " page.",
  notes: "Notes",
  attended: "Attended",
  delete: "Delete",
  attendanceFormError: "ATTENDANCE FORM ERROR",
  loading: "Loading...",
  goBack: "Go Back",
  confirm: "Confirm",
  questionMark: "?",
  eventName: "Event Name:",
  eventDate: "Event Date:",
  attendanceConfirm: "Attendance Confirmation",
  eventId: "Event Id: ",
  eventNotAvailablePartOne: "This attendance form is not available. The event may have been cancelled or rescheduled. Please ensure you are using the correct attendance form link for your event.",
  eventNotAvailablePartTwo: "If you are unable to use the attendance form on the day of the event, please capture the attendance on the spreadsheet attached to your joining instructions and send it to us via email.",
  linkIsNotActivePartOne: "This form is not yet available. The attendance forms are available for a limited time only. Please check again soon.",
  linkIsNotActivePartTwo: "If you are unable to use the attendance form on the day of the event, please capture the attendance on the spreadsheet attached to your joining instructions and send it to us via email.",
  linkExpiredPartOne: "This attendance form is no longer available. This is either because the attendance list has already been submitted or the event end date has passed.",
  linkExpiredPartTwo: "Attendance lists should be submitted within 24 hours of the event date. If you did not submit the attendance list in time, or need to make any changes, please contact us via email.",
  linkValidationFailInstructionMessage: "For further support please do not hesitate to contact our helpdesk. Contact details can be found on your joining instructions.",
  asteriskIndicateMessage: "An asterisk (*) indicates a mandatory field."
};
